"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KantimeHomecare = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class KantimeHomecare {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.gettingPatientDetails(pastedData);
            const insurance = this.getInsurance(pastedData);
            const contactDetails = this.getContactDetails(pastedData);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), contactDetails);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const patientInfoString = (0, helper_1.substrInBetweenNew)(sessionFirst, "Patient Intake Information", "Client Pay Billing Address");
        const Dob = (0, helper_1.substrInBetweenNew)(patientInfoString, "DOB:", "Age");
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(patientInfoString)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        let insurance = (0, helper_1.substrInBetweenNew)(sessionThird, "Payer 1:", "\n");
        insurance = insurance.replace("\n", " ");
        return {
            insurance,
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(contactDetails) {
        return {
            info: {
                physician: this.getPhysician(contactDetails),
                pharmacy: this.getPharmacy(contactDetails),
                careGiver: this.getCaregiver(contactDetails),
            },
        };
    }
    getPhysician(data) {
        const physicians = [];
        const physicianName = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(data, "Attending Physician:", "Address:"));
        const physicianInfoRaw = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(data, "Attending Physician:", "Primary Care Physician:"));
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)((0, helper_1.substrInBetweenNew)(physicianInfoRaw, "Phone:", "Fax:")).replace(/[\s-()]/g, ""));
        if (physicianName && phoneNo) {
            physicians.push({
                name: physicianName,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const pharmacyRaw = (0, helper_1.substrInBetweenInclusive)(data, "Scheduler:", "MBI:");
        const name = (0, helper_1.substrInBetweenNew)(pharmacyRaw, "Pharmacy:", "Phone");
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(pharmacyRaw, "Phone:", "Fax:");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        const contactPersonText = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(data, "Name Relation Priority Phone Email", "Emergency Contacts"));
        function getNameFromRaw(nameString) {
            const endIndex = Math.max(nameString.indexOf("Primary"), nameString.indexOf("Secondary"));
            return nameString.substring(0, endIndex);
        }
        return contactPersonText.split("\n").map((str, index) => {
            return {
                name: getNameFromRaw(str), //trim(pNumber).replace(/[\s-()]/g, "");
                phoneNo: (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)((0, helper_1.phoneNumbers)(str)[0]).replace(/[\s-()]/g, "")),
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: index + 1,
            };
        });
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const cellPhoneRaw = (0, helper_1.substrInBetweenNew)(firstSession, "Cell:", "Intake Status:");
        const cellPhoneNumber = (0, helper_1.trim)(cellPhoneRaw.replace(/[\s-()]/g, ""));
        info.phoneNo = (0, helper_1.changeNumberUSFormat)(cellPhoneNumber);
        const addressString = (0, helper_1.substrInBetweenNew)(firstSession, "Patient Information", "Address:");
        info.address.placeName = (0, helper_1.trim)(addressString);
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const nameText = (0, helper_1.substrInBetweenNew)(sessionFirst, "Patient:", "Location:");
        name.firstName = (0, helper_1.trim)(nameText.split(",")[1]);
        name.lastName = (0, helper_1.trim)(nameText.split(",")[0]);
        return name;
    }
}
exports.KantimeHomecare = KantimeHomecare;
